import * as React from "react";
import { Popup } from "react-map-gl";
import { styled } from "@mui/material/styles";

const StyledPopup = styled(Popup)({
  "& .maplibregl-popup-close-button": {
    width: "1.6rem",
    fontSize: "1.2rem",
    fontWieght: "bold",
    background: "#CCCCCC",
    borderBottomLeftRadius: "3px",
    "&:hover": {
      background: "#00AEEF",
    }
  },
  "& .maplibregl-popup-content": {
    padding: "0.8rem 0 0 0",
  },
  "&.popup-has-close-button .maplibregl-popup-content": {
    paddingTop: "1.6rem",
  },
});

const BasePopup = ({children, coords, ...props}) => {
  return (
    <StyledPopup
      className={props.closeButton ? "popup-has-close-button" : undefined}
      longitude={coords.lng}
      latitude={coords.lat}
      offset={[0, -5]}
      {...props}>
      {children}
    </StyledPopup>
  )
}

export default BasePopup;